import React, { useState } from 'react';
import styles from './Documents.module.css';

const Documents = () => {
  const [creditScore, setCreditScore] = useState('');
  const [income, setIncome] = useState('');
  const [background, setBackground] = useState('');
  const [consents, setConsents] = useState({
    creditPull: false,
    incomeVerification: false,
    backgroundCheck: false,
  });

  const toggleConsent = (type) => {
    setConsents(prev => ({ ...prev, [type]: !prev[type] }));
  };

  return (
    <div className={styles.container}>
      <div className={styles.leftSection}>
        <div className={styles.inputGroup}>
          <label>Self Report Credit Score</label>
          <input
            value={creditScore}
            onChange={(e) => setCreditScore(e.target.value)}
            placeholder="740"
          />
        </div>

        <div className={styles.inputGroup}>
          <label>Self Report Income</label>
          <input
            value={income}
            onChange={(e) => setIncome(e.target.value)}
            placeholder="$125,000"
          />
        </div>

        <div className={styles.inputGroup}>
          <label>Self Report Background</label>
          <input
            value={background}
            onChange={(e) => setBackground(e.target.value)}
            placeholder="None"
          />
        </div>
      </div>

      <div className={styles.verticalDivider}></div>

		<div className={styles.rightSection}>
		  <div className={styles.checkboxGroup}>
			<input
			  id="creditPull"
			  type="checkbox"
			  checked={consents.creditPull}
			  onChange={() => toggleConsent('creditPull')}
			/>
			<label htmlFor="creditPull">Credit Pull Consent</label>
		  </div>

		  <div className={styles.checkboxGroup}>
			<input
			  id="incomeVerification"
			  type="checkbox"
			  checked={consents.incomeVerification}
			  onChange={() => toggleConsent('incomeVerification')}
			/>
			<label htmlFor="incomeVerification">Income Verification Consent</label>
		  </div>

		  <div className={styles.checkboxGroup}>
			<input
			  id="backgroundCheck"
			  type="checkbox"
			  checked={consents.backgroundCheck}
			  onChange={() => toggleConsent('backgroundCheck')}
			/>
			<label htmlFor="backgroundCheck">Background Check Consent</label>
		  </div>
		</div>

    </div>
  );
};

export default Documents;
